import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 323 323"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M161.5 323C250.694 323 323 250.694 323 161.5C323 72.306 250.694 0 161.5 0C72.306 0 0 72.306 0 161.5C0 250.694 72.306 323 161.5 323Z",
                fill: "url(#paint0_radial_193_1390)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M46.9566 182.34H275.775C276.628 178.609 277.321 174.772 277.854 170.881H44.9312C45.4109 174.772 46.1038 178.556 46.9566 182.34Z",
                fill: "url(#paint1_linear_193_1390)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M68.5964 227.699H254.135C255.947 225.354 257.706 222.955 259.358 220.45H63.4263C65.0786 222.902 66.7842 225.354 68.5964 227.699Z",
                fill: "url(#paint2_linear_193_1390)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M82.6675 242.783H240.17C242.249 240.917 244.274 238.945 246.193 236.92H76.6445C78.5633 238.999 80.5888 240.917 82.6675 242.783Z",
                fill: "url(#paint3_linear_193_1390)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M103.614 257.921H219.223C221.675 256.535 224.073 255.042 226.472 253.497H96.4189C98.7109 255.042 101.163 256.535 103.614 257.921Z",
                fill: "url(#paint4_linear_193_1390)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M51.5937 197.425H271.191C272.417 194.12 273.536 190.816 274.496 187.351H48.2891C49.2485 190.816 50.3678 194.174 51.5937 197.425Z",
                fill: "url(#paint5_linear_193_1390)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M58.6289 212.561H264.155C265.701 209.736 267.193 206.858 268.472 203.927H54.2583C55.5908 206.858 57.0832 209.736 58.6289 212.561Z",
                fill: "url(#paint6_linear_193_1390)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M43.9185 155.637C43.9185 159.528 44.1317 163.419 44.5048 167.203H278.333C278.706 163.419 278.92 159.528 278.92 155.637C278.92 155.211 278.92 154.784 278.92 154.358H43.9185C43.9185 154.784 43.9185 155.211 43.9185 155.637Z",
                fill: "url(#paint7_linear_193_1390)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M45.2514 137.835C44.5585 142.525 44.1321 147.269 43.9722 152.066H278.813C278.654 147.216 278.227 142.472 277.534 137.835H45.2514Z",
                fill: "url(#paint8_linear_193_1390)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M157.715 273.058H165.07C173.012 272.791 180.794 271.778 188.309 270.02H134.476C141.991 271.778 149.719 272.791 157.715 273.058Z",
                fill: "url(#paint9_linear_193_1390)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M161.392 38.1631C102.868 38.1631 54.3651 80.9632 45.4106 136.982H277.374C268.419 80.9632 219.916 38.1631 161.392 38.1631Z",
                fill: "url(#paint10_linear_193_1390)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M226.838 100L205.255 172.952L183.672 100H181.549H142.51H140.328L118.745 172.952L97.1616 100H56L98.1641 242.526L98.0462 243H98.2821H139.208H139.503L139.326 242.526L162.029 165.959L184.674 242.526L184.556 243H184.792H225.718H226.013L225.836 242.526L268 100H226.838Z",
                fill: "url(#paint11_linear_193_1390)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M187.446 239.444L162.03 153.514L136.613 239.444H100.936L60.7178 103.556H94.567L118.745 185.338L142.982 103.556H181.077L205.255 185.338L229.492 103.556H263.282L223.123 239.444H187.446Z",
                fill: "url(#paint12_linear_193_1390)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M143.453 173.189C140.741 173.722 139.266 175.856 136.613 176.745C131.482 178.463 126.705 175.204 122.106 174.019L118.744 185.338L115.737 175.085C114.263 176.448 112.611 178.582 111.019 179.234C106.066 181.308 99.7558 179.886 94.7433 178.167C90.9102 176.863 89.5539 175.085 85.1311 174.967C84.0696 174.967 82.9492 175.026 81.8877 175.085L100.935 239.504H136.613L155.66 175.026C151.65 173.663 147.404 172.419 143.453 173.189Z",
                fill: "url(#paint13_linear_193_1390)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M237.748 175.145C234.092 175.382 231.202 174.078 227.782 174.078C223.713 174.019 223.064 176.745 219.526 177.811C215.28 179.056 212.096 176.034 208.322 175.204L205.314 185.397L202.425 175.678C201.245 176.211 200.125 176.982 198.415 177.871C188.802 182.73 186.326 174.967 177.421 175.145C173.883 175.204 171.642 176.448 168.988 177.1L187.446 239.503H223.123L242.171 175.204C240.697 175.085 239.222 175.026 237.748 175.145Z",
                fill: "url(#paint14_linear_193_1390)"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint0_radial_193_1390",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(161.507 161.507) scale(161.507)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#F24E61"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4064",
                                stopColor: "#EA4B5E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5376",
                                stopColor: "#EC3369",
                                stopOpacity: "0.779"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7147",
                                stopColor: "#EE1975",
                                stopOpacity: "0.4807"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8742",
                                stopColor: "#F0097C",
                                stopOpacity: "0.2119"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F0047F",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_193_1390",
                        x1: "161.402",
                        y1: "273.105",
                        x2: "161.402",
                        y2: "38.1695",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_193_1390",
                        x1: "161.402",
                        y1: "273.105",
                        x2: "161.402",
                        y2: "38.1687",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint3_linear_193_1390",
                        x1: "161.401",
                        y1: "273.105",
                        x2: "161.401",
                        y2: "38.1699",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint4_linear_193_1390",
                        x1: "161.401",
                        y1: "273.105",
                        x2: "161.401",
                        y2: "38.1689",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint5_linear_193_1390",
                        x1: "161.402",
                        y1: "273.106",
                        x2: "161.402",
                        y2: "38.1703",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint6_linear_193_1390",
                        x1: "161.401",
                        y1: "273.105",
                        x2: "161.401",
                        y2: "38.1695",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint7_linear_193_1390",
                        x1: "161.402",
                        y1: "273.105",
                        x2: "161.402",
                        y2: "38.1704",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint8_linear_193_1390",
                        x1: "161.402",
                        y1: "273.105",
                        x2: "161.402",
                        y2: "38.1694",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint9_linear_193_1390",
                        x1: "161.402",
                        y1: "273.105",
                        x2: "161.402",
                        y2: "38.1692",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint10_linear_193_1390",
                        x1: "161.401",
                        y1: "273.105",
                        x2: "161.401",
                        y2: "38.1697",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D434B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#F7931E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint11_linear_193_1390",
                        x1: "162.012",
                        y1: "97.7814",
                        x2: "162.012",
                        y2: "244.385",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1075",
                                stopColor: "#FFF9FD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2512",
                                stopColor: "#FFE8F8"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2848",
                                stopColor: "#FFE3F6"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.483",
                                stopColor: "#E2A1FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.6814",
                                stopColor: "#F5ADFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8457",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8506",
                                stopColor: "#FEF2F9"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8749",
                                stopColor: "#F8B3DD"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.899",
                                stopColor: "#F37CC4"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9222",
                                stopColor: "#EF50B0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9444",
                                stopColor: "#EC2DA0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9653",
                                stopColor: "#EA1495"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.9844",
                                stopColor: "#E8058E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E8008C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint12_linear_193_1390",
                        x1: "162.012",
                        y1: "102.498",
                        x2: "162.012",
                        y2: "236.547",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#000117"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1108",
                                stopColor: "#00466C"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.2551",
                                stopColor: "#009DD5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3196",
                                stopColor: "#00BFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4469",
                                stopColor: "#63DCFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5393",
                                stopColor: "#A4EFFF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5827",
                                stopColor: "#BDF6FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint13_linear_193_1390",
                        x1: "118.762",
                        y1: "172.441",
                        x2: "118.762",
                        y2: "238.623",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0134891",
                                stopColor: "#0C000D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0750203",
                                stopColor: "#160011"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1803",
                                stopColor: "#31001A"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3155",
                                stopColor: "#5D0029"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4274",
                                stopColor: "#870038"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.486",
                                stopColor: "#8D0342"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5841",
                                stopColor: "#9C0C5B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7096",
                                stopColor: "#B51A86"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8559",
                                stopColor: "#D72DBF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FC42FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint14_linear_193_1390",
                        x1: "205.549",
                        y1: "173.542",
                        x2: "205.549",
                        y2: "238.637",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0134891",
                                stopColor: "#0C000D"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.0750203",
                                stopColor: "#160011"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.1803",
                                stopColor: "#31001A"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.3155",
                                stopColor: "#5D0029"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.4274",
                                stopColor: "#870038"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.486",
                                stopColor: "#8D0342"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.5841",
                                stopColor: "#9C0C5B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.7096",
                                stopColor: "#B51A86"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.8559",
                                stopColor: "#D72DBF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FC42FF"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
export default Icon;
